module.exports = __webpack_public_path__ + "img/myriad_myraduntoken.9b431f2.png";